import About from './components/About'
import AnimatedSection from './components/AnimatedSection'
import Background from './components/Background'
import Experience from './components/Experience'
import Footer from './components/Footer'
import Header from './components/Header'
import Hero from './components/Hero'
import Projects from './components/Projects'
import { ThemeProvider } from './components/ThemeContext'

function App() {
  return (
    <ThemeProvider>
      <div className='top-0 bottom-0 z-[-2] absolute bg-[radial-gradient(ellipse_80%_80%_at_50%_-20%,rgba(217,216,255,0.5),rgba(255,255,255,0.9))] bg-gray-50 dark:bg-gray-950 dark:bg-[radial-gradient(ellipse_80%_80%_at_50%_-20%,rgba(120,119,198,0.3),rgba(255,255,255,0))] w-full min-h-screen'></div>
      <Background />
        <Header />
        <main className='px-4'>
          <Hero />
          <div className='space-y-24'>
            <AnimatedSection delay={0.2}>
              <Experience />
            </AnimatedSection>
            <AnimatedSection delay={0.4}>
              <Projects />
            </AnimatedSection>
            <AnimatedSection delay={0.6}>
              <About />
            </AnimatedSection>
          </div>
        </main>
        <Footer />
    </ThemeProvider>
  );
}

export default App
